export const MATCH_CARD_PICK_ROW_COPY = {
  MONKEY_PICK_LABEL: '🐵 Monkey pick',
} as const;

/** Accessibility label builders for the predicted-score stepper. */
export const MATCH_CARD_PICK_ROW_A11Y = {
  decrease: (teamLabel: string) => `Decrease ${teamLabel} predicted goals`,
  increase: (teamLabel: string) => `Increase ${teamLabel} predicted goals`,
  scoreForTeam: (teamLabel: string, score: number) =>
    `${teamLabel} predicted goals ${score}`,
} as const;
